<template>
   <div class="flex text-grey">
    <div class="flex justify-start w-1/2">
       not so good
    </div>
    <div class="flex justify-end w-1/2">
       good
    </div>
   </div>
</template>
<script>

export default {
  components: {
  },
  props: [],
  computed: {
  },
  methods: {
  }
}
</script>
